// extracted by mini-css-extract-plugin
export var categories = "blog-post-module--categories--SYz7f";
export var categoriesHeadline = "blog-post-module--categoriesHeadline--kifOF typography-module--base--YNU-U";
export var grid = "blog-post-module--grid--fElcv";
export var mainContent = "blog-post-module--mainContent--rXa+T";
export var metaContent = "blog-post-module--metaContent--QJX+7";
export var publishedAt = "blog-post-module--publishedAt--EfA5G typography-module--small--3rkeD";
export var root = "blog-post-module--root--U77l+";
export var title = "blog-post-module--title--KZe6I typography-module--responsiveTitle1--b0m8q";